const routerWebViewForum = {
  path: "/mobile/webViewForum",
  name: "webView",
  component: () => import("@/webViewForum/home.vue"),
  children: [
    // 嵌入到第三方的页面
    {
      path: "index",
      name: "mobile_viewWeb_forum_index",
      component: () => import("@/webViewForum/index"),
      meta: { name: "论坛" }
    },
    {
      path: "articleContent",
      name: "mobile_viewWeb_forum_articleContent",
      component: () => import("@/webViewForum/articleContent"),
      meta: { name: "详情" }
    },
    {
      path: "sendArticle",
      name: "mobile_viewWeb_forum_sendArticle",
      component: () => import("@/webViewForum/sendArticle"),
      meta: { name: "发布" }
    },
  ]
}

export default routerWebViewForum;


// WEBPACK FOOTER //
// ./src/router/routerWebViewForum.js